"use client";
import g from "./index.es259.js";
import r, { useRef as b, useLayoutEffect as v } from "react";
import w from "./index.es141.js";
let f = !1;
const x = 16, m = () => {
  document.querySelectorAll("span.has-tooltip").forEach((i) => {
    const n = i.getBoundingClientRect(), t = i.querySelector(".stat-richtext-tooltip"), s = i.querySelector(".stat-richtext-tooltip--inner");
    ({
      width: s?.clientWidth,
      height: (s?.clientHeight || 0) + x
    }).height > n.top ? t?.classList.add("stat-richtext-tooltip__below") : t?.classList.remove("stat-richtext-tooltip__below");
    const a = s?.getBoundingClientRect();
    a && a.left < 0 ? (t?.classList.add("stat-richtext-tooltip__right"), t?.classList.remove("stat-richtext-tooltip__left")) : (t?.classList.remove("stat-richtext-tooltip__right"), a && visualViewport && a.right > visualViewport.width ? (t?.classList.add("stat-richtext-tooltip__left"), t?.classList.remove("stat-richtext-tooltip__right")) : t?.classList.remove("stat-richtext-tooltip__left"));
  });
}, k = () => {
  f || (visualViewport && visualViewport.addEventListener("resize", m), document.addEventListener("scroll", m), f = !0);
}, _ = w.div`
  --stat-richtext-tooltip-margin-bottom: ${x}px;
  --stat-richtext-tooltip-width: 298px;
  --root-two: 1.414214;

  & > .bl-rich-text {
    & table {
      font-size: var(--bl-fs-2);
    }
    & ul {
      font-size: var(--bl-fs-2);
      line-height: 1.4em;
    }
  }

  & > .stat-larger.bl-rich-text {
    & p,
    ul,
    table,
    h5,
    h6 {
      font-size: var(--bl-fs-4);
    }
    h4 {
      font-size: var(--bl-fs-5);
    }
    h3 {
      font-size: var(--bl-fs-6);
    }

    & div.stat-richtext-tooltip p,
    h5 {
      font-size: 1em;
    }
  }

  & > .stat-richtext-tooltip {
    display: none;
  }
  & span.has-tooltip {
    position: relative;
    text-decoration: underline;
    cursor: pointer;
    font-weight: normal;
    &:hover,
    &:focus {
      background-color: #e1ebe4;
    }
    &:after {
      content: url('data:image/svg+xml;utf-8,<svg width="16" height="16" viewBox="0 0 16 16" fill="%232F6341" xmlns="http://www.w3.org/2000/svg"><path d="M15.4 8C15.4 12.0869 12.0869 15.4 8 15.4C3.91309 15.4 0.6 12.0869 0.6 8C0.6 3.91309 3.91309 0.6 8 0.6C12.0869 0.6 15.4 3.91309 15.4 8Z" stroke="%232f6341" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/><path d="M8 5.33334V8.00001" stroke="%23FFFFFF" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/><path d="M8 10.6667H8.00667" stroke="%23FFFFFF" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>');
    }
    .stat-richtext-tooltip {
      display: block;
      // tooltip positioning modifier code needs to use the dimensions of the child element to determine whether the tooltip should be left / right / top / bottom oriented.
      // therefore we hide this with height:0 overflow:hidden instead of display: none
      height: 0;
      overflow: hidden;
      position: absolute;
      bottom: 100%;
      background-color: transparent;
      left: calc(50% - (var(--stat-richtext-tooltip-width) / 2));
      min-width: var(--stat-richtext-tooltip-width);
    }

    .stat-richtext-tooltip--inner {
      position: relative;
      box-sizing: border-box;
      background-color: #ffffff;
      min-width: var(--stat-richtext-tooltip-width);
      margin-bottom: var(--stat-richtext-tooltip-margin-bottom);
      border: solid 2px #2f6341;

      & > p.strong {
        position: relative;
        width: auto;
        padding: 0.5rem 1rem 0.1rem;
        white-space: nowrap;
        background-color: #ffffff;
        font-weight: 800;
        z-index: 4;
      }

      & > p {
        position: relative;
        font-weight: normal;
        color: black;
        padding: 0 1rem 0.5rem;
        background-color: #ffffff;
        z-index: 4;
      }

      &:after {
        width: calc(
          var(--stat-richtext-tooltip-margin-bottom) * var(--root-two)
        );
        height: calc(
          var(--stat-richtext-tooltip-margin-bottom) * var(--root-two)
        );
        position: absolute;
        box-sizing: border-box;
        background-color: #fff;
        border: 2px solid #2f6341;
        bottom: calc(
          0px - (var(--stat-richtext-tooltip-margin-bottom) / var(--root-two))
        );
        transform: rotate(45deg);
        left: calc(
          (var(--stat-richtext-tooltip-width) / 2) - var(
              --stat-richtext-tooltip-margin-bottom
            )
        );
        content: '';
        z-index: 3;
      }
    }

    &:hover,
    &:focus {
      .stat-richtext-tooltip {
        display: block;
        width: var(--stat-richtext-tooltip-width);
        height: auto;
      }
      .stat-richtext-tooltip__below {
        top: 100%;
        bottom: auto;
        .stat-richtext-tooltip--inner {
          margin-top: var(--stat-richtext-tooltip-margin-bottom);
          margin-bottom: 0;
          &:after {
            bottom: auto;
            top: calc(
              0px -
                (var(--stat-richtext-tooltip-margin-bottom) / var(--root-two))
            );
          }
        }
      }

      .stat-richtext-tooltip__right {
        left: 0;
        .stat-richtext-tooltip--inner {
          &:after {
            left: 1rem;
            right: auto;
          }
        }
      }

      .stat-richtext-tooltip__left {
        right: 0;
        left: auto;
        .stat-richtext-tooltip--inner {
          &:after {
            right: 1rem;
            left: auto;
          }
        }
      }
    }
  }
`, y = (i, n) => i.querySelector(`.stat-richtext-tooltip[data-tooltip-key='${n}']`), F = ({
  content: i,
  keyContext: n,
  tooltips: t = [],
  className: s = ""
}) => {
  const a = b(null);
  return v(() => {
    const o = a.current;
    if (k(), o) {
      const u = o.querySelectorAll('a[href^="#"]');
      for (const e of u) {
        const h = e.hash.replace(/^#/, "");
        if (h && t.find((l) => l.key === h)) {
          const l = document.createElement("span");
          l.classList.add("has-tooltip"), l.tabIndex = 0;
          const p = y(o, h);
          if (p) {
            const c = p.getAttribute("data-tooltip-text");
            c && (e.innerText = c), e.insertAdjacentElement("beforeend", p), e.attributes.removeNamedItem("href"), e.addEventListener("click", (d) => {
              d.preventDefault();
            }), e.addEventListener("keydown", (d) => {
              d.key === "Escape" && e.blur();
            });
          }
          l.innerHTML = e.innerHTML, Array.from(e.attributes).forEach(
            (c) => l.setAttribute(c.name, c.value)
          ), e.parentNode.replaceChild(l, e);
        }
      }
    }
  }, [i]), /* @__PURE__ */ r.createElement(_, { ref: a }, /* @__PURE__ */ r.createElement(
    g,
    {
      className: `${s} bl-rich-text`,
      options: { forceBlock: !0, wrapper: "div", forceWrapper: !0 }
    },
    i || ""
  ), /* @__PURE__ */ r.createElement(r.Fragment, null, t && t.length > 0 && t.map((o) => /* @__PURE__ */ r.createElement(
    "div",
    {
      key: `${n}-tooltip-${o.key}`,
      "data-tooltip-key": o.key,
      className: "stat-richtext-tooltip bl-size-6",
      ...o.linkText ? { "data-tooltip-text": o.linkText } : {}
    },
    /* @__PURE__ */ r.createElement("div", { className: "stat-richtext-tooltip--inner" }, /* @__PURE__ */ r.createElement("p", { className: "strong" }, o.heading), /* @__PURE__ */ r.createElement("p", null, o.content))
  ))));
};
export {
  F as default
};
//# sourceMappingURL=index.es143.js.map
